
<template>
  <v-app>  
    <div id="mapid" style="height: 100%; width: 100%;"></div>
  </v-app>
</template>

<style>
#mapid {
  position: relative;
  height: 100% !important;
  z-index: 0;
}
</style>

<script>
import moment from "moment";
import vue from "vue";
import MapPopup from "../helpers/popup";

export default {
  name: "Map",
  data() {
    return {
      map: "",
      zoom: 17,
      otm: L.tileLayer("https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png", {
        id: "otm",
        attribution:
          'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
      }),
      osm: L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        id: "osm",
        attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }),
      mapbox: L.tileLayer(
        "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
        {
          id: "mapbox/streets-v11",
          accessToken: "your.mapbox.access.token",
          attribution:
            'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>'
        }
      ),
      mapMarkers: []
    };
  },
  props: {
    tracking_data: Array
  },
  methods: {
    initMap() {
      this.map = L.map("mapid", { layers: [this.osm] });
      L.control
        .layers(
          { "Open Street Map": this.osm },
          { "Open Topo Map": this.otm },
          { "Map Box": this.mapbox }
        )
        .addTo(this.map);
      this.setMapData();
    },

    setMapData() { 
      if (this.mapMarkers.length > 0) {
        for (var i = 0; i < this.mapMarkers.length; i++) {
          this.map.removeLayer(this.mapMarkers[i]);
        }
        this.mapMarkers = [];
      }

      if(this.tracking_data.length>0){
        var bound = [];
        this.tracking_data.map(vehicle => {
          var html = "";
          if (vehicle.speed == 0 && vehicle.engineon)
            html = '<span class="wlt_marker_icon IgnOn_SpdisZro"></span>';
          else if (vehicle.speed == 0 && !vehicle.engineon)
            html = '<span class="wlt_marker_icon IgnOff"></span>';
          else if (vehicle.speed > 0 && vehicle.speed <= 60)
            html =
              '<span class="wlt_marker_icon IgnOn_SpdnotZro" data-icon="dashicons:location" data-inline="false" data-rotate="90deg" ></span>';
          else if (vehicle.speed > 60)
            html =
              '<span class="wlt_marker_icon Overspid" data-icon="dashicons:location" data-inline="false" data-rotate="90deg" ></span>';

          var myIcon = L.divIcon({
            className: "my-div-icon",
            html: html
          });

          var popup = new vue({
            ...MapPopup,
            parent: this,
            propsData: { vehicle }
          }).$mount();

          bound.push(new L.LatLng(vehicle.lat, vehicle.lng));

          var marker = L.marker(
            [parseFloat(vehicle.lat), parseFloat(vehicle.lng)],
            {
              icon: myIcon
            }
          )
            .addTo(this.map)
            .bindPopup(popup.$el.innerHTML);
          this.mapMarkers.push(marker);
        });
        if (bound.length > 0) this.map.fitBounds(new L.LatLngBounds(bound));
      }
    }
  },
  mounted() {
    this.initMap();
  },
  watch:{

    tracking_data: function(newVal, oldVal) { 
      this.setMapData()
    }
  }
};
</script>
